export default __webpack_public_path__ + "static/media/check_circle.5757de77.svg";